export default "__VITE_ASSET__BI94AwbU__"